import React, { InputHTMLAttributes, TextareaHTMLAttributes } from "react";
import styled from "styled-components";

const Wrapper = styled.div`
  width: 100%;
  margin-bottom: 20px;
`;

const Input = styled.textarea`
  min-height: 42px;
  border: 1px solid #c9c9c9;
  width: 100%;
  font-size: 14px;
  color: #080808;
  opacity: 0.8;
  border-radius: 0px;
  padding: 0px 5px;
`;

const Label = styled.label`
  display: flex;
  font-weight: bold;
  margin-bottom: 5px;
  color: #080808;
  font-size: 14px;
`;

function TextArea({ inputLabel, ...rest }: ITextArea) {
  return (
    <Wrapper>
      {inputLabel && <Label htmlFor={"input-" + rest.name}>{inputLabel}</Label>}
      <Input id={"input-" + rest.name} {...rest} />
    </Wrapper>
  );
}

export interface ITextArea extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  inputLabel?: string;
}

export default TextArea;
